import FontsList from './FontsList';

export default FontsList;
